/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map 



//////////////////
// WEBPACK FOOTER
// /Users/thomas.obrien2/projects/nalgene/node_modules/rxjs/_esm5/util/identity.js
// module id = ../../../../rxjs/_esm5/util/identity.js
// module chunks = vendor